var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRejectedStatusIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.89868C0 4.4804 3.58172 0.898682 8 0.898682C12.4183 0.898682 16 4.4804 16 8.89868C16 13.317 12.4183 16.8987 8 16.8987C3.58172 16.8987 0 13.317 0 8.89868ZM11.2071 5.69158C11.5976 6.0821 11.5976 6.71526 11.2071 7.10579L9.41421 8.8987L11.2071 10.6916C11.5976 11.0821 11.5976 11.7153 11.2071 12.1058C10.8166 12.4963 10.1834 12.4963 9.79288 12.1058L8 10.3129L6.20714 12.1058C5.81661 12.4963 5.18345 12.4963 4.79292 12.1058C4.4024 11.7152 4.4024 11.0821 4.79292 10.6916L6.58578 8.8987L4.79289 7.10581C4.40237 6.71528 4.40237 6.08212 4.79289 5.69159C5.18342 5.30107 5.81658 5.30107 6.20711 5.69159L8 7.48448L9.79291 5.69158C10.1834 5.30105 10.8166 5.30105 11.2071 5.69158Z",
    fill: "#071A24"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRejectedStatusIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rejected-status-icon.a5b1eb00819cafe38e68e53f7235b603.svg";